import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 英文翻译
const enTranslations = {
  navigation: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    products: 'Products',
    projects: 'Projects',
    blog: 'Blog',
    contact: 'Contact',
    getQuote: 'Get a Quote',
  },
  common: {
    readMore: 'Read More',
    viewAll: 'View All',
    submit: 'Submit',
    loading: 'Loading...',
    learnMore: 'Learn More',
    viewAllServices: 'View All Services',
    viewAllProjects: 'View All Projects',
    contactUs: 'Contact Us',
    contactInfo: 'Contact Information',
    phone: 'Phone',
    cell: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    address: 'Address',
    close: 'Close',
    viewDetails: 'View Details',
    years: 'Years of Experience',
    projects: 'Projects Completed',
    staff: 'Professional Staff',
    awards: 'Industry Awards',
    saveChanges: 'Save Changes',
    add: 'Add',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    value: 'Value',
    label: 'Label',
    stats: 'Statistics',
  },
  home: {
    hero: {
      title: 'Welcome to Dozer',
      subtitle: 'Your Partner for Quality Construction',
      description: 'We provide cutting-edge solutions with the highest quality service to meet your needs.',
      cta: {
        primary: 'Our Products',
        secondary: 'Contact Us',
      },
    },
    features: {
      title: 'Our Features',
      experiencedTeam: 'Experienced Team',
      experiencedTeamDesc: 'Our expert team brings years of industry experience to your project.',
      qualityGuarantee: 'Quality Guarantee',
      qualityGuaranteeDesc: 'We stand behind our work with a 100% quality guarantee.',
      modernEquipment: 'Modern Equipment',
      modernEquipmentDesc: 'Using the latest technology for efficient and precise results.',
      support: '24/7 Support',
      supportDesc: 'Round-the-clock customer service for all your needs.',
    },
    about: {
      title: 'About Our Company',
      subtitle: 'Professional Excellence Since 1995',
      description: 'For over 25 years, we have been delivering exceptional service and innovative solutions to our clients. Our commitment to quality and customer satisfaction has made us a leader in the industry.',
    },
    services: {
      title: 'Our Products',
      subtitle: 'What We Offer',
      excavation: 'Excavation',
      excavationDesc: 'Professional excavation services for commercial and residential projects.',
      grading: 'Grading',
      gradingDesc: 'Precise grading services to ensure proper drainage and foundation.',
      demolition: 'Demolition',
      demolitionDesc: 'Safe and efficient demolition services for all project sizes.',
      landClearing: 'Land Clearing',
      landClearingDesc: 'Comprehensive land clearing for development or landscaping.',
    },
    testimonials: {
      title: 'What Clients Say',
      subtitle: 'Testimonials',
    },
    projects: {
      title: 'Recent Projects',
      subtitle: 'Our Work Speaks For Itself',
      commercialDev: 'Commercial Development',
      commercialDevDesc: 'Commercial site preparation and excavation',
      residentialSub: 'Residential Subdivision',
      residentialSubDesc: 'Land clearing and grading for new housing development',
      highwayExp: 'Highway Expansion',
      highwayExpDesc: 'Major excavation work for highway widening project',
    },
    contact: {
      title: 'Get In Touch',
      subtitle: 'Ready to start your project?',
      description: 'Contact us today for a free consultation and quote.',
    },
  },
  about: {
    title: 'About Us',
    subtitle: 'Our Story',
    description: 'Learn about our company history and values.',
  },
  services: {
    title: 'Our Products',
    subtitle: 'What We Do Best',
    description: 'Explore our range of professional services.',
    needHelp: 'Need Help With Your Project?',
    contactMessage: 'Contact our team today for a consultation on your specific service needs. We\'re here to help you achieve the best results.',
  },
  projects: {
    title: 'Our Projects',
    subtitle: 'Our Portfolio',
    description: 'See our completed projects and success stories.',
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Get In Touch',
    description: 'Reach out to us for inquiries or quotes.',
    formName: 'Name',
    formEmail: 'Email',
    formPhone: 'Phone',
    formMessage: 'Message',
    formSubmit: 'Send Message',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
  },
  admin: {
    dashboard: 'Dashboard',
    content: 'Content Management',
    siteSettings: 'Site Settings',
    media: 'Media Library',
    users: 'User Management',
    logout: 'Logout',
    siteTitle: 'Site Title',
    siteDescription: 'Site Description',
    contactInfo: 'Contact Information',
    social: 'Social Media',
    titleEN: 'Title (English)',
    titleZH: 'Title (中文)',
    subtitleEN: 'Subtitle (English)',
    subtitleZH: 'Subtitle (中文)',
    descriptionEN: 'Description (English)',
    descriptionZH: 'Description (中文)',
    save: 'Save Changes',
    addNew: 'Add New',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete this item?',
    labelEN: 'Label (English)',
    labelZH: 'Label (中文)',
    image: 'Image URL',
    icon: 'Icon',
    name: 'Name',
    position: 'Position',
    rating: 'Rating',
    testimonialText: 'Testimonial Text',
    path: 'Path',
    aboutSection: 'About Section',
    featuresSection: 'Features Section',
    servicesSection: 'Services Section',
    testimonialsSection: 'Testimonials Section',
    projectsSection: 'Projects Section',
    contactSection: 'Contact Section',
    title: 'Title',
    subtitle: 'Subtitle',
    shortDescription: 'Short Description',
    detailedContent: 'Detailed Content',
    englishContent: 'English Content',
    chineseContent: 'Chinese Content',
    addNewItem: 'Add New Item',
    materialIconName: 'Enter Material UI icon name',
    serviceImage: 'Service Image',
    imageURL: 'Image URL',
    pasteImageURL: 'Paste image URL or select from Media Library',
    linkPath: 'Link Path',
    editingService: 'Editing Service',
    contentDashboard: 'Content Management Dashboard',
    welcomeToContentManagement: 'Welcome to the content management system. Here you can edit all content displayed on your website.',
    quickStart: 'Quick Start Guide',
    editHome: 'Edit Home Page',
    editHomeDesc: 'Update hero section, features, and other home page content',
    editServices: 'Edit Services',
    editServicesDesc: 'Manage your service offerings, descriptions and images',
    manageContent: 'Manage All Content',
    manageContentDesc: 'Update any section of your website using the tabs above',
    contentTips: 'Content Tips',
    keepItSimple: 'Keep Content Simple',
    keepItSimpleDesc: 'Use clear, concise language that\'s easy for visitors to understand',
    useImages: 'Use High-Quality Images',
    useImagesDesc: 'Add professional images to make your content more engaging',
    testChanges: 'Test Your Changes',
    testChangesDesc: 'Preview the site after making changes to ensure everything looks good',
  },
  footer: {
    aboutUs: 'About Us',
    quickLinks: 'Quick Links',
    services: 'Services',
    contact: 'Contact',
    copyright: '© 2023 Dozer. All rights reserved.',
  },
};

// 中文翻译
const zhTranslations = {
  navigation: {
    home: '首页',
    about: '关于我们',
    services: '服务项目',
    projects: '工程案例',
    blog: '博客',
    contact: '联系我们',
    getQuote: '获取报价',
  },
  common: {
    readMore: '阅读更多',
    viewAll: '查看全部',
    submit: '提交',
    loading: '加载中...',
    learnMore: '了解更多',
    viewAllServices: '查看所有服务',
    viewAllProjects: '查看所有项目',
    contactUs: '联系我们',
    contactInfo: '联系信息',
    phone: '电话',
    cell: '手机',
    fax: '传真',
    email: '电子邮件',
    address: '地址',
    close: '关闭',
    viewDetails: '查看详情',
    years: '年经验',
    projects: '已完成项目',
    staff: '专业人员',
    awards: '行业奖项',
    saveChanges: '保存修改',
    add: '添加',
    delete: '删除',
    cancel: '取消',
    confirm: '确认',
    value: '数值',
    label: '标签',
    stats: '统计数据',
  },
  home: {
    hero: {
      title: '欢迎来到道择工程',
      subtitle: '您的高品质建筑服务合作伙伴',
      description: '我们提供前沿解决方案，以最高质量的服务满足您的需求。',
      cta: {
        primary: '我们的服务',
        secondary: '联系我们',
      },
    },
    features: {
      title: '我们的优势',
      experiencedTeam: '经验丰富的团队',
      experiencedTeamDesc: '我们的专家团队为您的项目带来多年的行业经验。',
      qualityGuarantee: '质量保证',
      qualityGuaranteeDesc: '我们的工作提供100%的质量保证。',
      modernEquipment: '现代化设备',
      modernEquipmentDesc: '使用最新技术，确保高效精确的结果。',
      support: '24/7全天候支持',
      supportDesc: '全天候客户服务，满足您的所有需求。',
    },
    about: {
      title: '关于我们',
      subtitle: '自1995年以来的专业服务',
      description: '25年来，我们一直为客户提供卓越的服务和创新解决方案。我们对质量和客户满意度的承诺使我们成为行业的领导者。',
    },
    services: {
      title: '服务项目',
      subtitle: '我们能为您做什么',
      excavation: '挖掘服务',
      excavationDesc: '为商业和住宅项目提供专业挖掘服务。',
      grading: '平整服务',
      gradingDesc: '精确的平整服务，确保适当的排水和基础。',
      demolition: '拆除服务',
      demolitionDesc: '为各种规模的项目提供安全高效的拆除服务。',
      landClearing: '土地清理',
      landClearingDesc: '为开发或景观提供全面的土地清理。',
    },
    testimonials: {
      title: '客户评价',
      subtitle: '他们对我们的评价',
    },
    projects: {
      title: '近期项目',
      subtitle: '我们的工程案例',
      commercialDev: '商业开发',
      commercialDevDesc: '商业地点准备和挖掘',
      residentialSub: '住宅小区',
      residentialSubDesc: '为新住宅开发进行土地清理和平整',
      highwayExp: '高速公路扩建',
      highwayExpDesc: '高速公路拓宽项目的主要挖掘工作',
    },
    contact: {
      title: '联系我们',
      subtitle: '准备开始您的项目了吗？',
      description: '立即联系我们获取免费咨询和报价。',
    },
  },
  about: {
    title: '关于我们',
    subtitle: '我们的故事',
    description: '了解我们公司的历史和价值观。',
  },
  services: {
    title: '服务项目',
    subtitle: '我们的专业领域',
    description: '探索我们的专业服务范围。',
    needHelp: '需要项目帮助？',
    contactMessage: '立即联系我们的团队，针对您的特定服务需求进行咨询。我们随时为您提供最佳解决方案。',
  },
  projects: {
    title: '工程案例',
    subtitle: '我们的项目集',
    description: '查看我们已完成的项目和成功案例。',
  },
  contact: {
    title: '联系我们',
    subtitle: '联系方式',
    description: '有任何咨询或报价需求，请联系我们。',
    formName: '姓名',
    formEmail: '电子邮箱',
    formPhone: '电话',
    formMessage: '留言',
    formSubmit: '发送消息',
    address: '地址',
    phone: '电话',
    email: '电子邮箱',
  },
  admin: {
    dashboard: '控制面板',
    content: '内容管理',
    siteSettings: '网站设置',
    media: '媒体库',
    users: '用户管理',
    logout: '退出登录',
    siteTitle: '网站标题',
    siteDescription: '网站描述',
    contactInfo: '联系方式',
    social: '社交媒体',
    titleEN: '标题 (英文)',
    titleZH: '标题 (中文)',
    subtitleEN: '副标题 (英文)',
    subtitleZH: '副标题 (中文)',
    descriptionEN: '描述 (英文)',
    descriptionZH: '描述 (中文)',
    save: '保存更改',
    addNew: '新增',
    delete: '删除',
    confirmDelete: '确定要删除此项吗？',
    labelEN: '标签 (英文)',
    labelZH: '标签 (中文)',
    image: '图片链接',
    icon: '图标',
    name: '名称',
    position: '职位',
    rating: '评分',
    testimonialText: '推荐语',
    path: '路径',
    aboutSection: '关于部分',
    featuresSection: '特点部分',
    servicesSection: '服务部分',
    testimonialsSection: '推荐部分',
    projectsSection: '项目部分',
    contactSection: '联系部分',
    title: '标题',
    subtitle: '副标题',
    shortDescription: '简短描述',
    detailedContent: '详细内容',
    englishContent: '英文内容',
    chineseContent: '中文内容',
    addNewItem: '添加新项目',
    materialIconName: '输入Material UI图标名称',
    serviceImage: '服务图片',
    imageURL: '图片URL',
    pasteImageURL: '粘贴图片链接或从媒体库选择',
    linkPath: '链接路径',
    editingService: '编辑服务',
    contentDashboard: '内容管理控制台',
    welcomeToContentManagement: '欢迎使用内容管理系统。您可以在这里编辑网站上显示的所有内容。',
    quickStart: '快速入门指南',
    editHome: '编辑首页',
    editHomeDesc: '更新首页的英雄部分、特点和其他内容',
    editServices: '编辑服务',
    editServicesDesc: '管理您提供的服务、描述和图片',
    manageContent: '管理所有内容',
    manageContentDesc: '使用上方的选项卡更新网站的任何部分',
    contentTips: '内容技巧',
    keepItSimple: '保持内容简洁',
    keepItSimpleDesc: '使用清晰、简洁的语言，便于访问者理解',
    useImages: '使用高质量图片',
    useImagesDesc: '添加专业图片使您的内容更具吸引力',
    testChanges: '测试您的更改',
    testChangesDesc: '更改后预览网站，确保一切看起来都很好',
  },
  footer: {
    aboutUs: '关于我们',
    quickLinks: '快速链接',
    services: '服务项目',
    contact: '联系我们',
    copyright: '© 2023 道择. 保留所有权利。',
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      zh: {
        translation: zhTranslations,
      },
    },
    fallbackLng: 'en',
    lng: 'en',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 